import React from "react";

type Props = {};

const RenderLoading = (props: Props) => {
  return <div>RenderLoading</div>;
};

export default RenderLoading;
